import { remoteConfigWrap } from "src/tags/remote-config"
import React, { memo, useCallback, useEffect, useRef, useState } from "react"
import { Button } from "src/components/parts/buttons/Button"
import { Dimensions, Image, Linking } from "react-native"
import { useCheckPCScreen } from "src/hooks/useCheckPCScreen"
import { RemoteConfigBanners } from "src/constants/RemoteConfigBanners"
import { useFocusEffect } from "@react-navigation/native"
import { Analytics } from "src/tags/analytics/Analytics"

type Props = {
  bannerKey: RemoteConfigBanners
  isShowByPaidTeam: boolean
}

export const RemoteConfigBanner = memo<Props>(({ bannerKey, isShowByPaidTeam }) => {
  const [imageUrl, setImageUrl] = useState("")
  const [destinationUrl, setDestinationUrl] = useState("")
  const [adId, setAdId] = useState("")
  const isLargeScreen = useCheckPCScreen()
  const [aspectRatio, setAspectRatio] = useState(1)
  const screenWidth = Dimensions.get("window").width
  const isAdShowRef = useRef(false)
  const isAdClickRef = useRef(false)

  useFocusEffect(
    useCallback(() => {
      const bannerNumber = bannerKey === RemoteConfigBanners.Home ? 1 : bannerKey === RemoteConfigBanners.Renraku ? 2 : null
      remoteConfigWrap.fetchAndActivate().then(async () => {
        const remoteValue = remoteConfigWrap.getJson(bannerKey)
        if (remoteValue.img !== "") {
          const { width, height } = await getImageSize(remoteValue.img)
          setAspectRatio(width / height)
        }
        setImageUrl(remoteValue.img)
        setDestinationUrl(remoteValue.url)

        if (remoteValue.id && bannerNumber) {
          setAdId(`${remoteValue.id}_バナー${bannerNumber}`)
        }
      })
      return () => {
        setAdId("")
        isAdShowRef.current = false
        isAdClickRef.current = false
      }
    }, [bannerKey])
  )

  useEffect(() => {
    const showAdBanner = async () => {
      await Analytics.showAdBanner(adId)
      isAdShowRef.current = true
    }
    if (imageUrl && destinationUrl && adId && isShowByPaidTeam && !isAdShowRef.current) {
      showAdBanner()
    }
  }, [imageUrl, destinationUrl, adId, isShowByPaidTeam])

  const getImageSize = (uri: string): Promise<{ width: number; height: number }> => {
    return new Promise((resolve, reject) => {
      Image.getSize(
        uri,
        (width, height) => resolve({ width, height }),
        (error) => reject(error)
      )
    })
  }

  const onBannerClick = async () => {
    if (adId && !isAdClickRef.current) {
      await Analytics.clickAdBanner(adId)
      isAdClickRef.current = true
    }

    try {
      await Linking.openURL(destinationUrl)
    } catch (e) {
      console.warn("Failed to open the link", e)
    }
  }

  return (
    <>
      {!isLargeScreen && isShowByPaidTeam && imageUrl && destinationUrl ? (
        <Button
          onPress={onBannerClick}
          style={{
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Image
            source={{ uri: imageUrl }}
            style={{
              width: screenWidth,
              height: screenWidth / aspectRatio,
              resizeMode: "contain",
            }}
          />
        </Button>
      ) : null}
    </>
  )
})
